import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { ConsoleLogger } from 'src/lib/console-logger'
import {
  ChangePageRequest,
  PointHistoryPeriod,
} from 'src/lib/entity/gift-point'

@Component({
  selector: 'maglive-point-history-all',
  templateUrl: './point-history-all.component.html',
  styleUrls: ['./point-history-all.component.scss'],
})
export class PointHistoryAllComponent implements OnInit {
  @Input() isShowPointHistoryAllPage: boolean
  @Input() pointHistoryPeriod: PointHistoryPeriod | 'NOT_FOUND'
  @Output() changePageEvent = new EventEmitter<ChangePageRequest>()

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    // ロールバック対策
    // console.log(this.pointHistoryPeriod)
    // history.pushState(null, null, location.href)
    // window.addEventListener('popstate', this.browserBack)

    if (this.pointHistoryPeriod !== 'NOT_FOUND') {
      if (this.pointHistoryPeriod.items.length === 0) {
        this.pointHistoryPeriod = 'NOT_FOUND'
      }
    }
  }

  // ngOnDestroy() {
  //   window.removeEventListener('popstate', this.browserBack)
  // }

  showPointHistoryDetail(yearMonth: string) {
    this.changePageEvent.emit({ name: 'HISTORY_DETAIL', yearMonth: yearMonth })
  }

  /**
   * ブラウザバック押下時の挙動。同期遷移させない。
   */
  browserBack = (e) => {
    e.preventDefault()
    history.go(1)
    this.changePageEvent.emit({ name: 'MANAGE' })
    console.log('detail')
    e.stopImmediatePropagation()
  }
}
